/**
 * PATH: packages/bills/src/components/LineItemsSection.tsx
 * FILE_ID: BILLS-PKG-CMP-LINES-009
 * PURPOSE: Thin Section wrapper around the shared `BillLineItemsEditor` (the
 *          single source of truth for the editable Excel-style row table,
 *          reused by the List inline detail / drawer so the two editors never
 *          drift).
 *
 * WHY: Keeps the "Line items (N)" heading + count wiring next to the editor it
 *      wraps. Extracted from BillDataPanel.tsx (P4-1 split) — no behaviour
 *      change.
 */

import { Section } from './BillFieldPrimitives';
import { BillLineItemsEditor } from './BillLineItemsEditor';
import type { BillLineItem } from '../types';

export function LineItemsSection({
  items,
  onChange,
}: {
  items: BillLineItem[];
  onChange: (items: BillLineItem[]) => void;
}) {
  return (
    <Section title={`Line items (${items.length})`}>
      <BillLineItemsEditor items={items} onChange={onChange} />
    </Section>
  );
}
